const Hero = () => (
    <section id="hero">
        <div>
            <p>Hello, my name is</p>
            <h1>Karl Christian Leonardo</h1>
            <p className="details">
                I'm a software engineer with more than 5 years of experience specializing in web development and cloud technologies. I have a passion for creating efficient, user-friendly applications and a keen interest in modern web technologies.
            </p>
        </div>
        <svg className="svg-curve" viewBox="0 0 1440 79" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 60 C 240 10, 480 90, 720 60 C 960 30, 1200 90, 1440 60 L 1440 0 L 0 0 Z"></path>
        </svg>
    </section>
);
export default Hero;